<style lang="scss">
.ann-dialog {
    border-radius: 20px;
    .notice-dialog-body {
        max-height: 600px;
        overflow: auto;
        overflow-x: hidden;
        word-wrap: break-word;
    }
}
@media (min-height: 800px) {
    .md2_login {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        margin: 0 !important;
    }
}
.md2_login {
    width: 1340px;
    height: 700px;
    margin: 50px auto;
    //  margin: 30px 0;
    background: white;
    border-radius: 70px;
    .banner {
        position: relative;
        // background-image: url(../../assets/images/banner.png);
        width: 100%;
        height: 364px;
        display: flex;
        flex-direction: row-reverse;
        // padding: 0 160px;
        box-sizing: border-box;
        .loginBox {
            position: absolute;
            z-index: 100;
            right: 160px;
        }
        .carousel {
            height: 364px;
            width: 100%;
            a {
                display: block;
                width: 100%;
                height: 100%;
            }
            .el-carousel__container {
                height: 364px;
            }
            img {
                width: 100%;
                height: 364px;
                border-radius: 70px 70px 0 0;
            }
        }
    }
    .el-dialog {
        z-index: 2003;
    }

    .listBox {
        margin-top: 30px;
        width: 100%;
        flex-direction: row;
        .list {
            width: 446px;
            box-sizing: border-box;
            padding: 0 45px;
        }
        .list_title {
            height: 20px;
            display: flex;
            align-items: center;
            justify-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-weight: bold;
            margin: 10px 0;
            .iconfont {
                color: #c4c4c4;
                font-size: 16px;
                margin-right: 10px;
            }
        }
        .more {
            display: block;
            padding-left: 25px;
            font-size: 10px;
            color: #303133;
            text-decoration: underline;
            font-weight: 500;
            &:hover {
                color: #409eff;
                text-decoration: underline;
            }
        }
        .process {
            padding: 10px 45px;
            box-sizing: border-box;
            .processPic {
                width: 700px;
                padding: 10px 0;
                img {
                    width: 100%;
                }
            }
        }
        .list_item {
            & > div {
                width: 356px;
                overflow: hidden;
                margin-bottom: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                &:hover {
                    color: #409eff;
                    cursor: pointer;
                }
            }
            padding-left: 25px;
            font-size: 14px;
            color: #606266;
            line-height: 30px;
            vertical-align: middle;
        }
    }
}
</style>
<template>
    <div class="md2_login">
        <div class="banner">
            <el-carousel
                class="carousel"
                :autoplay="false"
            >
                <el-carousel-item
                    v-for="item,index in bannerList"
                    :key="index"
                >
                    <a
                        :href="item.link_address"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            :src="item.proc_id"
                            alt
                        />
                    </a>
                </el-carousel-item>
            </el-carousel>
            <div class="loginBox">
                <m2Login
                    class="m2Login"
                    v-if="loginInform&&!isMobile"
                ></m2Login>
                <m2Login
                    class="m2Login"
                    v-if="loginInform&&isMobile"
                ></m2Login>
                <m2Logined
                    class="m2Logined"
                    v-if="!loginInform&&!isMobile"
                    :name="userName"
                ></m2Logined>
                <m2Logined
                    class="m2Logined"
                    v-if="!loginInform&&isMobile"
                    :name="userName"
                ></m2Logined>
            </div>
        </div>
        <div class="flexbox listBox">
            <div class="list">
                <div class="list_title">
                    <div>
                        <span class="iconfont icon-wenti"></span>
                        <span>问题解答</span>
                    </div>
                    <router-link
                        class="more"
                        v-if="quesTotalCount>5"
                        :to="{name:'default_moreProblemSolving'}"
                    >更多</router-link>
                </div>
                <div class="list_item">
                    <div
                        v-for="quesInform in quesInforms"
                        @click="getAnnouncement(quesInform.id,'normal')"
                    >
                        <span>{{quesInform.title}}</span>
                    </div>
                </div>
            </div>
            <div>
                <div class="flexbox">
                    <div class="list">
                        <div class="list_title">
                            <div>
                                <span class="iconfont icon-xiaoxi"></span>
                                <span>通知公告</span>
                            </div>

                            <router-link
                                class="more"
                                v-if="testTotalCount>5"
                                :to="{name:'default_moreAnnoucement'}"
                            >更多</router-link>
                        </div>
                        <div class="list_item">
                            <div
                                v-for="testInform in testInforms"
                                @click="getAnnouncement(testInform.id,'normal')"
                            >
                                <span>{{testInform.title}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                        <div class="list_title">
                            <div>
                                <span class="iconfont icon-zhengce"></span>
                                <span>政策制度</span>
                            </div>
                            <router-link
                                class="more"
                                v-if="policyTotalCount>5"
                                :to="{name:'default_morePolicySystem'}"
                            >更多</router-link>
                        </div>
                        <div class="list_item">
                            <div
                                v-for="policyInform in policyInforms"
                                @click="getAnnouncement(policyInform.id,'normal')"
                            >
                                <span>{{policyInform.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            custom-class="ann-dialog"
            :visible.sync="dialogVisible"
            center
            :append-to-body="true"
        >
            <span
                slot="title"
                class="notice-dialog-title"
            >{{one_notice.title}}</span>
            <div
                v-html="one_notice.content"
                class="notice-dialog-body"
            ></div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="dialogVisible = false"
                >已阅读</el-button>
            </span>
        </el-dialog>
        <el-dialog
            custom-class="ann-dialog"
            :close-on-click-modal="false"
            :show-close="false"
            :append-to-body="true"
            :visible.sync="tipDialogVisible"
            center
        >
            <span
                slot="title"
                class="notice-dialog-title"
            >{{this_notice.title}}</span>
            <div
                class="notice-dialog-body"
                v-html="this_notice.content"
            ></div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    v-if="tipNoticeList.length>1&&tipNoticeNum!=0"
                    @click="tipNoticeNum = tipNoticeNum-1"
                >上一条</el-button>
                <el-button
                    type="primary"
                    @click="tipDialogVisible = false"
                    v-if="(tipNoticeList.length-1)===tipNoticeNum"
                >已阅读</el-button>
                <el-button
                    type="primary"
                    v-if="tipNoticeList.length>1&&(tipNoticeList.length-1)!=tipNoticeNum"
                    @click="tipNoticeNum = tipNoticeNum+1"
                >下一条</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import m2Login from "@components/login/m2_login.vue";
import m2Logined from "@components/logined/m2_logined.vue";
export default {
    components: {
        m2Login,
        m2Logined
    },
    data: function() {
        return {
            user: {},
            testInforms: [],
            quesInforms: [],
            policyInforms: [],
            tipNoticeList: [],
            tipNoticeNum: 0,
            dialogVisible: false,
            tipDialogVisible: false,
            testTotalCount: "",
            quesTotalCount: "",
            policyTotalCount: "",
            one_notice: {
                content: "",
                title: "",
                proc_id: ""
            },
            haveTip: false,
            this_notice: {
                content: "",
                title: "",
                proc_id: ""
            },
            isMobile: false
        };
    },
    created: function() {
        var ua = navigator.userAgent;
        var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
            isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
            isAndroid = ua.match(/(Android)\s+([\d.]+)/);
        this.isMobile = isIphone || isAndroid;
        this.$store.commit("setHeaderState", "1");
    },
    computed: {
        userName: function() {
            if (this.$store.state.common.currentUser == null) {
                this.$http.get(globalProvider.serviceUrl("pc/g")).then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.$store.commit("setCurrentUser", data.body.data);
                        return this.$store.state.common.currentUser.name;
                    }
                });
            } else {
                return this.$store.state.common.currentUser.name;
            }
        },
        loginInform: function() {
            this.user = this.$store.state.common.token;
            return !this.user;
        },
        api_state: function() {
            return this.$store.state.examInfo.currentExamInfo.api_state;
        },
        bannerList: function() {
            if (this.$store.state.examInfo.currentExamInfo.template_info_list) {
                let arr = this.$store.state.examInfo.currentExamInfo.template_info_list.filter(
                    item => {
                        item.link_address = "http://" + item.link_address;
                        return item.proc_id != null;
                    }
                );
                return arr;
            }
            return [];
        },
        user_type: function() {
            if (this.$store.state.common.userType != null) {
                if (
                    this.$store.state.common.userType.if_bind_user &&
                    this.$store.state.common.token != null
                ) {
                    this.getNoReadTipAnnouncement();
                }
                if (
                    this.$store.state.common.userType.if_bind_user &&
                    this.$store.state.common.currentUser == null
                ) {
                    this.$http
                        .get(globalProvider.serviceUrl("pc/g"))
                        .then(data => {
                            if (data.body.code == resultCode.Success) {
                                this.$store.commit(
                                    "setCurrentUser",
                                    data.body.data
                                );
                            }
                        });
                }
            }
            return this.$store.state.common.userType;
        }
    },
    watch: {
        api_state: function(curVal, oldVal) {
            if (this.$store.state.examInfo.currentExamInfo.api_state) {
                this.getData();
            }
        },
        tipNoticeNum(curVal, oldVal) {
            this.getAnnouncement(this.tipNoticeList[curVal], "tip");
        }
    },
    methods: {
        getNormalAnn: function(captcha_token) {
             let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT';
            }
            this.$http
                .get(
                    globalProvider.serviceUrl(
                       url
                    ),
                    {
                        params: {
                            domain: this.$route.params.projectCode,
                            page_index: 1,
                            page_size: 5,
                            n_type: "se"
                        },
                        headers: {
                            ttoken: captcha_token
                        },
                        emulateJSON: false
                    }
                )
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 1) {
                                this.testInforms = item._items;
                                this.testTotalCount = item.totalCount;
                            } else if (item.type == 2) {
                                this.quesInforms = item._items;
                                this.quesTotalCount = item.totalCount;
                            } else if (item.type == 3) {
                                this.policyInforms = item._items;
                                this.policyTotalCount = item.totalCount;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        },
        set_captcha_token: function(callback) {
            this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
                if (data.body.code == resultCode.Success) {
                    callback(data.body.data);
                }
            });
        },
        getTipAnnouncement: function(captcha_token) {
            let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/tnis/{domain}/se/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/tnis/{domain}/se/PROJECT';
            }
            this.$http
                .get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: this.$route.params.projectCode
                    },
                    headers: {
                        ttoken: captcha_token
                    },
                    emulateJSON: false
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        if (data.body.data.length > 0) {
                            this.tipNoticeList = data.body.data;
                            this.tipDialogVisible = true;
                            this.getAnnouncement(this.tipNoticeList[0]);
                        }
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        },
        getNoReadTipAnnouncement: function() {
            let url;
            if(this.$route.params.batchCode){
                url = 'ea/g/utnis/BATCH/'+this.$route.params.batchCode;
            }else{
                url = 'ea/g/utnis/PROJECT';
            }
            if (!this.haveTip) {
                this.$http
                    .get(globalProvider.serviceUrl(url))
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            if (data.body.data.length > 0) {
                                this.tipNoticeList = data.body.data;
                                this.haveTip = true;
                                this.tipDialogVisible = true;
                                this.getAnnouncement(this.tipNoticeList[0]);
                            }
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(
                                getErrorMessage(data.body.message),
                                "提示",
                                {
                                    confirmButtonText: "确定"
                                }
                            );
                        }
                    });
            }
        },
        getAnnouncement: function(notice_id, id) {
            if (id === "normal") {
                document.getElementsByClassName(
                    "notice-dialog-body"
                ).scrollTop = 0;
                this.dialogVisible = true;
                this.$http
                    .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
                        params: {
                            notice_id: notice_id
                        }
                    })
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            this.one_notice = data.body.data;
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(
                                getErrorMessage(data.body.message),
                                "提示",
                                {
                                    confirmButtonText: "确定"
                                }
                            );
                        }
                    });
            } else {
                this.$http
                    .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
                        params: {
                            notice_id: notice_id
                        }
                    })
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            this.this_notice = data.body.data;
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(
                                getErrorMessage(data.body.message),
                                "提示",
                                {
                                    confirmButtonText: "确定"
                                }
                            );
                        }
                    });
            }
        },
        getData() {
            if (this.$store.state.common.token != null) {
                this.getNormalAnn();
            } else {
                this.set_captcha_token(this.getNormalAnn);
                this.set_captcha_token(this.getTipAnnouncement);
            }
        }
    }
};
</script>